import { EVENT_CLICK_TYPE } from '../../../../constants/utils';
import { ClickEventAnalytics } from '../../../../models/utils';
import { AnalyticsBaseClick } from '../../../../models/utils/analytics-extended.interfaces';

export function resolveEventAndAction(
  base: AnalyticsBaseClick
): [string, string] {
  if (base.componentType) {
    return [base.details.eventDetail, base.details.action];
  }
  if (isAttributeOrButton(base)) {
    return [base.details.action, base.details.action];
  }
  return [base.details.eventDetail, base.details.eventDetail];
}

export function buildClickPayload(
  base: AnalyticsBaseClick,
  action: string
): ClickEventAnalytics['click'] {
  const click: ClickEventAnalytics['click'] = {
    name: base.details.label.toLowerCase(),
    type: base.type,
    page_section: base.details.pageSection,
    action
  };
  if (base.componentType && base.componentName) {
    click.component_name = base.componentName.toLowerCase();
    click.component_type = base.componentType.toLowerCase();
  }
  return click;
}

export function isAttributeOrButton(base: AnalyticsBaseClick): boolean {
  return !!(
    base.pageAttribute ||
    base.type === EVENT_CLICK_TYPE.BUTTON ||
    base.linkWithoutAction
  );
}

export function findComponentAction(
  elementRef: HTMLElement,
  getElementAction: (el: HTMLElement) => string
): string {
  const component = elementRef.closest('[data-acdl-component-type]');
  const candidates = [
    getElementAction(elementRef),
    component
      ?.querySelector<HTMLAnchorElement>('a[href]:not([href="#"])')
      ?.getAttribute('href'),
    component
      ?.querySelector<HTMLButtonElement>('button[data-href]')
      ?.getAttribute('data-href')
  ];
  return candidates.find((v) => v && v !== '#') ?? '';
}
